import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=2ae95e36"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
import style0 from "./Container.vue?vue&type=style&index=0&id=2ae95e36&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae95e36')) {
      api.createRecord('2ae95e36', component.options)
    } else {
      api.reload('2ae95e36', component.options)
    }
    module.hot.accept("./Container.vue?vue&type=template&id=2ae95e36", function () {
      api.rerender('2ae95e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fumigation/Container.vue"
export default component.exports